import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalError } from 'src/app/pago/models/ModalError.model';

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
})
export class ModalErrorComponent implements OnChanges {
  @Input() error: ModalError;
  @ViewChild('modalError') modalError: TemplateRef<any>;
  @Output() handleSubmitModalError: EventEmitter<any> = new EventEmitter();

  constructor(private ngbModal: NgbModal) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.error.currentValue.active) {
      this.ngbModal.open(this.modalError, {
        backdrop: 'static',
        keyboard: false,
        centered: true,
      });
    }
  }

  onSubmit() {
    if (this.error.buttonAction) {
      window.location.replace(this.error.buttonAction);
    }
    this.handleSubmitModalError.emit();
    this.ngbModal.dismissAll();
  }
}
